module.exports = __webpack_public_path__ + "img/zyjy_14.b6985cce.png";